import React, { useRef, useCallback } from "react";
import { Paper } from "@mui/material";

/**
 * ダイアログをドラッグ移動できる Paper コンポーネント。
 * Dialog の PaperComponent に指定して使用する。
 * DialogTitle に data-drag-handle 属性を付けることでドラッグハンドルになる。
 */
export default function DraggablePaper({ onMouseDown: _, ...props }) {
  const paperRef = useRef(null);
  const pos = useRef({ x: 0, y: 0 });

  const handleMouseDown = useCallback((e) => {
    if (!e.target.closest("[data-drag-handle]")) return;
    const startX = e.clientX - pos.current.x;
    const startY = e.clientY - pos.current.y;

    const onMove = (e) => {
      pos.current = { x: e.clientX - startX, y: e.clientY - startY };
      if (paperRef.current) {
        paperRef.current.style.transform =
          `translate(${pos.current.x}px, ${pos.current.y}px)`;
      }
    };
    const onUp = () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  }, []);

  return <Paper {...props} ref={paperRef} onMouseDown={handleMouseDown} />;
}
